import { getRouteApi, useRouter, useSearch } from "@tanstack/react-router";
import { Route } from "@/routes/__root";
import { useClient } from "creso-core/hooks";
import { TransactionListDialog as SharedTransactionListDialog } from "web-core";

/**
 * Partners adapter for the shared transaction list dialog: reads the
 * `modal=transaction-list` search params and closes by going back.
 */
export function TransactionListDialog() {
  const { isin, client_id, folio_id } = useSearch({
    from: Route.id,
  });

  const clientRoute = getRouteApi("/(auth)/_headed/clients/$id");

  const { source } = clientRoute.useSearch();

  const { data: client, isLoading: isLoadingClients } = useClient(
    Number(client_id) ?? 0
  );

  const router = useRouter();

  return (
    <SharedTransactionListDialog
      open
      onOpenChange={(open) => {
        if (!open) {
          router.history.back();
        }
      }}
      investmentAccount={client?.investment_account ?? undefined}
      isin={isin || ""}
      source={source}
      folioId={folio_id}
      isLoading={isLoadingClients}
    />
  );
}
